module.exports = __webpack_public_path__ + "static/media/Dchat.f7e258f1.svg";